import { toast } from "react-toastify";

const toastList = new Set();
const MAX_TOAST = 2;

export const notify = (test, message) => {
	if (test && toastList.size === 0) {
		// Only show notification if no other notifications are active
		let id;
		if (message === "success") {
			id = toast.success(test, {
				autoClose: 2000,
				onClose: () => toastList.delete(id),
			});
		} else {
			id = toast.error(test, {
				autoClose: 2000,
				onClose: () => toastList.delete(id),
			});
		}
		toastList.add(id);
	}
};

export const notifyAPIMessages = (res) => {
	if (res) {
		if (res?.status === 200 || res?.status === 201) {
			notify(res?.data?.message, "success");
		} else {
			const errorMessage = res?.response
				? res?.response?.data?.message
				: res?.message;
			notify(errorMessage, "error");
		}
	}
};

export const formatDateToYMD = (dateString) => {
	if (!dateString) return "";
  
	const date = new Date(dateString);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
	const day = String(date.getDate()).padStart(2, "0");
  
	return `${year}-${month}-${day}`;
  };

  export const displayDateAsDMY = (dateString) => {
	if (!dateString) return "";
  
	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
	const year = date.getFullYear();
  
	return `${day}/${month}/${year}`;
  };